import { Box } from '@mui/material';
import { useQuery } from 'react-query';

import useIsMobileSize from 'src/hooks/useIsMobileSize';
import LeadStreamsService from 'src/services/LeadStreamsService';
import { shouldShowStreamInMenu } from 'src/utils/leadStreams';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';

import BottomSheetHeader from '../BottomSheetHeader';
import { getStreamsFilter } from '../FeedFilter/utils';
import FilterItem from '../FeedFilter/Components/FilterItem';

export default function StreamsSheet() {
    const isMobile = useIsMobileSize();
    const { data: streams = [], isLoading } = useQuery({
        queryKey: LeadStreamsService.queryKey,
        queryFn: LeadStreamsService.getStreams,
        onError: () => {},
        select: (data) => data.filter(shouldShowStreamInMenu),
    });

    const item = getStreamsFilter(streams, isMobile);

    return (
        <Box
            px={1}
            sx={{
                maxHeight: '70vh',
                overflow: 'auto',
            }}
        >
            <BottomSheetHeader title="Потоки лидов" />
            <LoadingWrapper isLoading={isLoading}>
                <FilterItem
                    key={item.title}
                    {...item}
                />
            </LoadingWrapper>
        </Box>
    );
}
